define('modules/base/views/get.more.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/base/views/base.view"
], function(
    Prospector,
    $,_,Backbone,Marionette, BaseView
){
    var GetMoreView = BaseView.extend({
        mEvents:function() {
            var base = {
                'click .getMoreBtn': 'getMoreModels'
            };
            return base;
        },
        debugName: 'Get More View',
        getMoreModels: function(){
            this.addLoader();
            this.parent.getMoreModels();
        },
        addLoader:function(){
            this.$('.getMoreBtn').hide();
            this.$('.getMoreLoader').show();
        },
        removeLoader:function(){
            this.$('.getMoreLoader').hide();
            this.$('.getMoreBtn').show();
        }

    });
    return GetMoreView;
});

